const { app } = Mobi2Go;

const fetchEndpoint = endpoint => {
    return new Promise((resolve, reject) => {
        app.serverRequest({
            api_version: 1,
            with_credentials: false,
            endpoint: `policy/${endpoint}`,
            success: response => {
                const url = stripAndCleanHTMLResponse(response);
                if (url !== null) {
                    resolve(url);
                } else {
                    reject(
                        new Error(`No link found for endpoint: ${endpoint}`)
                    );
                }
            },
            error: error => {
                reject(error);
            },
        });
    });
};

const stripAndCleanHTMLResponse = response => {
    const parser = new DOMParser();
    const html_doc = parser.parseFromString(response, 'text/html');
    const p_tag = html_doc.querySelector('p');
    if (p_tag && p_tag.childNodes.length === 1) {
        const first_child = p_tag.firstChild;
        if (
            first_child &&
            first_child.nodeType === Node.ELEMENT_NODE &&
            first_child.tagName.toLowerCase() === 'a'
        ) {
            const link = first_child;
            if (link) {
                return link.href;
            }
        }
    }
    return null;
};

export { fetchEndpoint, stripAndCleanHTMLResponse };
